import { useCallback } from "react";
import { toast } from "react-toastify";
import { apiClient } from "../../../../api/httpClient";

/** PG `/guardian-details` fetch + fills principal row fields. */
export function useBondPrincipalPgFetch({ cfg, keys, updateData, dataRef }) {
  const fetchProfessionalGuardianDetails = useCallback(
    async (index, id) => {
      try {
        const response = await apiClient(`/guardian-details/${id}/`, "GET");

        const missingAddressParts = [];
        if (!response.mailing_address) missingAddressParts.push("Street Address");
        if (!response.city) missingAddressParts.push("City");
        if (!response.state) missingAddressParts.push("State");
        if (!response.zip_code) missingAddressParts.push("ZIP/Postal Code");

        if (cfg.toastOnIncompletePgAddress && missingAddressParts.length > 0) {
          toast.warning(
            `${response.full_name || "Selected Professional Guardian"}'s address ` +
              `on file is incomplete (missing: ${missingAddressParts.join(", ")}). ` +
              `Please update the Professional Guardian record before continuing.`,
            { autoClose: 8000 }
          );
        }

        const currentData = dataRef.current;
        const updatedGuardians = Array.isArray(currentData.guardians)
          ? [...currentData.guardians]
          : [];

        const basePatch = {
          [keys.name]: response.full_name,
          [keys.address]: response.mailing_address,
          email: response.email,
          [keys.city]: response.city,
          [keys.state]: response.state,
          [keys.zip]: response.zip_code,
          professional_guardian: id,
          is_professional_guardian: "Yes",
          is_new_pg: false,
          showFullForm: false,
          pg_address_raw: response.mailing_address_raw,
          pg_address_missing_parts: missingAddressParts,
        };

        if (cfg.pgFetchIncludesBilling) {
          basePatch.preferred_billing = response.preferred_billing;
        }

        if (cfg.pgFetchIncludesGiaLoa) {
          const pgGia = !!response.is_gia_on_file;
          const pgLoa = !!response.is_loa_on_file;
          basePatch.pg_gia_on_file = pgGia;
          basePatch.pg_loa_on_file = pgLoa;
          basePatch.is_esignatures_principal = pgGia
            ? "No"
            : updatedGuardians[index].is_esignatures_principal || "No";
        }

        updatedGuardians[index] = {
          ...updatedGuardians[index],
          ...basePatch,
        };
        updateData({ ...currentData, guardians: updatedGuardians });
      } catch (error) {
        console.error("Error fetching professional guardian details", error);
      }
    },
    [cfg, dataRef, keys, updateData]
  );

  return { fetchProfessionalGuardianDetails };
}
